import { CSSTransition } from 'react-transition-group';
import { useCarousel } from './hooks/useCarousel';
import { useGetParams } from './hooks/useGetParams';
import defaultBackground from './assets/images/bg.png';

import MessagesList from './components/MessagesList/MessagesList';
import { useMemo } from 'react';
import Advt from './components/Advt/Advt';
import logo from './assets/images/logo.png';

function App() {
  const {
    currentState,
    isVisible,
    showedMessages,
    messagesRef,
    winnerMessage,
    speed,
  } = useCarousel();
  const {
    bg,
    authorFontSize,
    msgFontSize,
    phoneNumberFontSize,
    phoneNumber,
    socials,
    title,
    qrCode1,
    qrCode2,
    qrTitle1,
    qrTitle2,
    paddingQR,
    bgColor,
  } = useGetParams();

  const advt_info = useMemo(
    () => ({
      qrCode1: qrCode1,
      qrCode2: qrCode2,
      qrTitle1: qrTitle1,
      qrTitle2: qrTitle2,
      label: title,
      number: phoneNumber,
      socials: socials?.split(','),
    }),
    [phoneNumber, socials, title, qrCode1, qrCode2, qrTitle1, qrTitle2]
  );

  return (
    <div
      className="app-wrapper"
      style={{
        background:
          bg && bg !== '0'
            ? `url(${
                bg === '1' ? defaultBackground : bg
              }) no-repeat, ${bgColor}`
            : `none, ${bgColor}`,
        backgroundSize: '61.04rem 100vh, 100%',
        backgroundPosition: 'left, center',
        '--speed': `${speed || 0}ms`,
        '--delay': `${speed / 2 || 0}ms`,
      }}>
      <CSSTransition
        in={isVisible && Boolean(currentState)}
        timeout={500}
        classNames="fade-scale"
        unmountOnExit>
        <div className="advt-wrapper">
          {advt_info && <Advt advtInfo={advt_info} paddingQR={paddingQR} />}
        </div>
      </CSSTransition>

      <CSSTransition
        in={isVisible}
        timeout={500}
        classNames="fade-scale"
        unmountOnExit>
        <div className="message-wrapper">
          <CSSTransition
            in={showedMessages && Boolean(currentState)}
            timeout={500}
            // classNames="fade-scale"
            unmountOnExit>
            <MessagesList
              winId={winnerMessage?.message.id}
              messages={showedMessages}
              authorFontSize={authorFontSize}
              msgFontSize={msgFontSize}
              phoneNumberFontSize={phoneNumberFontSize}
              currentState={currentState}
              speed={speed || 0}
            />
          </CSSTransition>
        </div>
      </CSSTransition>
      <div className="logo">
        <img src={logo} alt="Логотип" />
      </div>
      <div id="img-loader"></div>
    </div>
  );
}

export default App;
